// extracted by mini-css-extract-plugin
export default {"top":"DirectionalArrow_top__9OLe7","right":"DirectionalArrow_right__aaxs5","down":"DirectionalArrow_down__K4LKw","left":"DirectionalArrow_left__bcaUK"};